import Swal from "sweetalert2";
import { toast } from "react-toastify";
export async function askConfirmation(
  message,
  confirmButtonText,
  cancelButtonText,
) {
  let isConfirmed = false;
  await Swal.fire({
    icon: "question",
    title: "<small><b>Confirmation</b></small>",
    html: message,
    //showCloseButton: true,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonText:
      "<span style='font-size:14px;'>" +
      (confirmButtonText === "" || confirmButtonText === null
        ? ""
        : confirmButtonText) +
      " </span>",
    cancelButtonText:
      cancelButtonText === "" || cancelButtonText === null
        ? "No"
        : cancelButtonText,
    confirmButtonColor: "#d33",
    cancelButtonColor: "#121212",
    //dangerMode: false,
    allowOutsideClick: false,
  }).then(async (result) => {
    if (result.isConfirmed) {
      isConfirmed = true;
    }
  });
  return isConfirmed;
}
export async function showResponseMessage({ isSuccess, message }) {
  let isConfirmed = false;
  await Swal.fire({
    allowOutsideClick: false,
    icon: isSuccess ? "success" : "error",
    title: isSuccess ? "Success" : "Oops...",
    text:
      isSuccess === false && (message === null || message === "")
        ? "Unable to process the request."
        : message === null || message === ""
          ? "Request processed successfully."
          : message,
    //html: "Sorry! We are unable to process you request.<br/>Please try after some times.Sorry! We are unable to process you request.<br/>Please try after some times.",
  }).then(async (result) => {
    if (result.isConfirmed) {
      isConfirmed = true;
    }
  });
  return isConfirmed;
}
// ── Toasts: non-blocking messages (results of saves/loads). Use the popups below only
// when the user must read or answer before going on (e.g. askConfirmation). ──────────
const TOAST_OPTIONS = {
  position: toast.POSITION.TOP_CENTER,
  style: { width: "310px" },
  hideProgressBar: false,
  newestOnTop: false,
  closeButton: false,
};
const DEFAULT_ERROR = "Sorry! We are unable to process your request. Please try after some time.";
const textOr = (message, fallback) =>
  message === null || message === undefined || String(message).trim() === "" ? fallback : message;

export function showSuccessToast(message) {
  toast.success(textOr(message, "Request processed successfully."), { ...TOAST_OPTIONS, autoClose: 2500 });
}
export function showErrorToast(message) {
  // Errors stay a little longer so they can be read.
  toast.error(textOr(message, DEFAULT_ERROR), { ...TOAST_OPTIONS, autoClose: 4000 });
}
export function showWarningToast(message) {
  toast.warn(textOr(message, DEFAULT_ERROR), { ...TOAST_OPTIONS, autoClose: 3500 });
}
export function showInfoToast(message) {
  toast.info(textOr(message, ""), { ...TOAST_OPTIONS, autoClose: 2500 });
}
/** Toast for an API result { isSuccess, message }. Returns isSuccess. */
export function showResponseToast({ isSuccess, message }) {
  if (isSuccess) showSuccessToast(message);
  else showErrorToast(textOr(message, "Unable to process the request."));
  return Boolean(isSuccess);
}

export async function showResponseMessageWithErrorInToast({
  isSuccess,
  message,
}) {
  if (!isSuccess) {
    showErrorToast(message);
    return false;
  }
  let isConfirmed = false;
  await Swal.fire({
    allowOutsideClick: false,
    icon: isSuccess ? "success" : "error",
    title: isSuccess ? "Success" : "Oops...",
    text:
      isSuccess === false && (message === null || message === "")
        ? "Unable to process the request."
        : message === null || message === ""
          ? "Request processed successfully."
          : message,
    //html: "Sorry! We are unable to process you request.<br/>Please try after some times.Sorry! We are unable to process you request.<br/>Please try after some times.",
  }).then(async (result) => {
    if (result.isConfirmed) {
      isConfirmed = true;
    }
  });
  return isConfirmed;
}
export async function showUnderDevelopmentMessage() {
  await Swal.fire({
    allowOutsideClick: false,
    showCloseButton: true,
    icon: "warning",
    title: "Request Failed!",
    html: "Sorry! We are unable to process you request.<br/>Please try after some times.",
  });
}
export async function showSuccessMessage(message, title = "") {
  await Swal.fire({
    allowOutsideClick: false,
    showCloseButton: true,
    icon: "success",
    title,
    text: message ?? "Success",
  });
}
export async function showWarningMessage(message, title = "") {
  await Swal.fire({
    allowOutsideClick: false,
    showCloseButton: true,
    icon: "warning",
    title,
    html:
      message ??
      "Sorry! We are unable to process you request.<br/>Please try after some times.",
  });
}
export async function showErrorMessage(message) {
  await Swal.fire({
    allowOutsideClick: false,
    showCloseButton: true,
    icon: "error",
    title: "Oops...",
    html:
      message ??
      "Sorry! We are unable to process you request.<br/>Please try after some times.",
  });
}
export async function showInfoMessage(message, title = "") {
  await Swal.fire({
    allowOutsideClick: false,
    showCloseButton: true,
    icon: "info",
    title,
    text: message ?? "Success",
  });
}
